import { Action, combineReducers, createReducer, on } from '@ngrx/store'
import {
  CashFlowsChartType,
  CashFlowsAxisType,
  CashFlowsGraphData,
} from '../../model/credit-cash-flows.model'
import { CreditModelScenarioGlsMapping } from '../../model/credit-portfolio.model'
import { CreditTransaction } from '../../model/credit-structure.model'
import { CreditResults } from '../../model/credit-results.model'
import { CreditStructureActions } from '../structure/credit-structure.actions'
import { CreditSubmissionStructureActions } from '../submission/credit-submission.actions'
import * as fromCashFlowsActions from './cash-flows.actions'
import * as fromCreditActions from '../credit.actions'

export interface State {
  currentCashFlowsChartType: CashFlowsChartType
  currentCashFlowsAxisType: CashFlowsAxisType
  currentCashFlowsScenario?: CreditModelScenarioGlsMapping
  currentCashFlowsTransaction?: CreditTransaction
  currentCashFlowsData?: CashFlowsGraphData
  currentCashFlowsCreditResults?: CreditResults
}

export const initialState: State = {
  currentCashFlowsChartType: CashFlowsChartType.Area,
  currentCashFlowsAxisType: CashFlowsAxisType.Currency,
}

const currentCashFlowsChartTypeReducer = createReducer(
  initialState.currentCashFlowsChartType,
  on(fromCashFlowsActions.SetCashFlowsChartType, (_, { chartType }) => chartType),
)

const currentCashFlowsAxisTypeReducer = createReducer(
  initialState.currentCashFlowsAxisType,
  on(fromCashFlowsActions.SetCashFlowsAxisType, (_, { axisType }) => axisType),
)

const currentCashFlowsScenarioReducer = createReducer(
  initialState.currentCashFlowsScenario,
  on(fromCashFlowsActions.SetCashFlowsScenario, (_, { scenario }) => scenario),
  on(
    fromCreditActions.SetModuleContext,
    CreditStructureActions.resetSelectedStructure,
    CreditSubmissionStructureActions.resetSelectedSubmission,
    () => undefined as CreditModelScenarioGlsMapping,
  ),
)

const currentCashFlowsTransactionReducer = createReducer(
  initialState.currentCashFlowsTransaction,
  on(fromCashFlowsActions.SetCashFlowsTransaction, (_, { transaction }) => transaction),
  on(
    fromCreditActions.SetModuleContext,
    CreditStructureActions.resetSelectedStructure,
    CreditSubmissionStructureActions.resetSelectedSubmission,
    () => undefined as CreditTransaction,
  ),
)

const currentCashFlowsDataReducer = createReducer(
  initialState.currentCashFlowsData,
  on(fromCashFlowsActions.GetCashFlowsDataSuccess, (_, { data }) => data),
  on(
    fromCreditActions.SetModuleContext,
    CreditStructureActions.resetSelectedStructure,
    CreditSubmissionStructureActions.resetSelectedSubmission,
    () => undefined as CashFlowsGraphData,
  ),
)

const currentCashFlowsLayerResultsReducer = createReducer(
  initialState.currentCashFlowsCreditResults,
  on(fromCashFlowsActions.GetCashFlowsLayerResultsSuccess, (_, { results }) => results),
  on(
    fromCreditActions.SetModuleContext,
    CreditStructureActions.resetSelectedStructure,
    CreditSubmissionStructureActions.resetSelectedSubmission,
    () => undefined as CreditResults,
  ),
)

const cashFlowsReducer = combineReducers<State>({
  currentCashFlowsChartType: currentCashFlowsChartTypeReducer,
  currentCashFlowsAxisType: currentCashFlowsAxisTypeReducer,
  currentCashFlowsScenario: currentCashFlowsScenarioReducer,
  currentCashFlowsTransaction: currentCashFlowsTransactionReducer,
  currentCashFlowsData: currentCashFlowsDataReducer,
  currentCashFlowsCreditResults: currentCashFlowsLayerResultsReducer,
})

export function reducer(state: State | undefined, action: Action) {
  return cashFlowsReducer(state, action)
}
